import Highcharts from 'highcharts'
import HighchartsMoreFn from 'highcharts/highcharts-more'
import HighchartsAccessibilityFn from 'highcharts/modules/accessibility'

HighchartsMoreFn(Highcharts)
HighchartsAccessibilityFn(Highcharts)

export function recommendChartInit(_seriesData, spMark) {
    //data
    drawRecommendChart('recommend_chart',_seriesData, spMark);
}

export function drawRecommendChart(divId, lineData, spMark){
    var seriesColors = ['#EAB308', '#A8A29E', '#D97706', '#94A3B8', '#94A3B8']

    let seriesData = [];

    if(lineData.series != null) {
        for(let i = 0; i < lineData.series.length; i++){
            let series = {
                data: lineData.series[i].data,
                pointPlacement: 'on',
                animation: false,
                lineWidth: 2,
                color: seriesColors[i],
                zIndex: 7 - i,
                marker:{
                    radius: 4,
                    symbol: 'circle',
                    states: {
                        hover: {
                            radius: 5.4
                        },
                        select: {
                            radius: 5.4
                        }
                    }
                },
                states: {
                    inactive: {
                        opacity: 1
                    }
                }
            }
            seriesData.push(series);
        }
    }

    var analysisOption = {
        credits: {
            enabled: false,
        },
        chart: {
            backgroundColor: 'transparent',
            type: 'line',
            height: 570,
            width: 450,
            marginTop: -90,
            marginBottom: -40,
            marginLeft: 24,
            marginRight: 48
        },
        title: {
            text: ''
        },
        tooltip: {
          enabled: false
        },
        xAxis: {
            title: {
                text: '圏外',
                offset: 0,
                x: 223,
                y: -108,
                style: {
                    fontFamily: "-apple-system,\'BlinkMacSystemFont\',\'Hiragino Kaku Gothic ProN\',\'Noto Sans CJK JP\',\'Noto Sans JP\',\'Noto Sans\',sans-serif",
                    fontSize: '13px',
                    fontWeight: 'bold',
                    color: '#334155'
                }
            },
            categories: lineData.categories,
            tickmarkPlacement: 'on',
            lineWidth: 0,
            gridLineWidth: 0,
            labels: {
                useHTML: true,
                autoRotation: false,
                formatter: function () {
                    var labelHtml = this.value;
                    if(labelHtml.includes('直近')){
                        labelHtml = '直近' + '<br><span class="fsm">'+ labelHtml.replace('直近', '') +'</span>'
                    }
                    return labelHtml
                },
                style: {
                    fontFamily: "-apple-system,\'BlinkMacSystemFont\',\'Hiragino Kaku Gothic ProN\',\'Noto Sans CJK JP\',\'Noto Sans JP\',\'Noto Sans\',sans-serif",
                    fontSize: '14px',
                    fontWeight: 'bold',
                    color: '#334155',
                    textOverflow: 'clip',
                    textAlign: 'center',
                    lineHeight: '1',
                    height: '32px',
                    display: 'flex',
                    flexWrap: 'wrap',
                    alignItems: 'center',
                    justifyContent: 'center'
                },
                y: -68
            }
        },
        yAxis: {
            title: {
                text: null
            },
            gridLineColor: "#DEDEDE",
            gridLineWidth: 1,
            lineWidth: 0,
            min: 0,
            tickAmount: 8,
            tickPositions: [0, 1, 2, 3, 4, 5, 6, 7],
            reversed: true,
            labels: {
                enabled: false
            }
        },
        legend: {
            enabled: false
        },
        pane: {
            size: '73%'
        },
        series: seriesData
    };

    var spWidth = $(window).width();

    if(spMark == 'sp') {
        analysisOption.chart.width = null;
        analysisOption.chart.height = 260;
        analysisOption.chart.marginTop = -30;
        analysisOption.chart.marginBottom = 10;
        analysisOption.chart.marginLeft = 16;
        analysisOption.xAxis.labels.y = -10;
        analysisOption.xAxis.labels.style.fontSize = '12.25px';
        analysisOption.xAxis.labels.style.height = '30px';
        analysisOption.xAxis.title.x = spWidth / 2 - 16;
        analysisOption.xAxis.title.y = -50;
    }

    var recommendChart = Highcharts.chart(divId, analysisOption);

    $(window).on('resize', function () {
        if(spMark == 'sp') {
            var spWidth = $(window).width();
            recommendChart.update({
                xAxis: {
                    title: {
                        x: spWidth / 2 - 16
                    }
                }
            })
        }
    })
}

export default { recommendChartInit, drawRecommendChart };